import styled from 'styled-components';

export const Item = styled.div`
  padding: 20px 40px 35px 40px;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 3px;
  margin: 0 -15px 20px;

  @media only screen and (max-width: 767px) {
    padding: 35px 15px;
  }

  .pt-20 {
    padding-top: 20px;
  }

  .early-bird {
    color: #28c397;
    font-size: 15px;
    border: 1px solid #28c397;
    letter-spacing: -0.3px;
    min-width: 166px;
    font-weight: 700;
    padding: 0 4px;
    font-family: 'Be Vietnam Pro';
  }

  .fully-booked {
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.18px;
    line-height: 28px;
    text-align: center;
    position: relative;
    background-color: #000000;
    padding: 9px 15px;
    font-family: 'Be Vietnam Pro';
    font-weight: 600;
  }

  .seats-count {
    color: #28c397;
    margin: 10px;
    font-family: 'Be Vietnam Pro';
    min-height: 23px;
  }

  .course-description {
    font-size: 16px;
    color: #898989;
    font-family: 'Be Vietnam Pro';
  }

  @media screen and (max-width: 450px) {
    .early-bird {
      font-size: 14px;
    }
  }
  & > div {
    margin: 0 15px;

    @media only screen and (max-width: 767px) {
      min-width: calc(50% - 30px);

      &:first-child {
        order: 3;
      }

      &:nth-child(2) {
        order: 2;
      }

      &:nth-child(3) {
        order: 1;
      }

      &:last-child {
        order: 4;
      }
    }

    @media screen and (max-width: 450px) {
      &:last-child {
        padding-top: 20px;
      }
    }

    &:first-child,
    &:nth-child(2),
    &:last-child {
      flex: 1;
    }

    span {
      display: inline-block;
      color: ${({ theme: { colors } }) => colors.darkGrey};
    }

    &:first-child {
      .date {
        font-size: 30px;
        letter-spacing: -0.27px;
        line-height: 1.13;
        max-width: 174px;

        @media only screen and (max-width: 767px) {
          font-size: 24px;
        }
      }

      .time {
        font-size: 16px;
        letter-spacing: 0.06px;
        line-height: 30px;
      }

      .location {
        font-weight: bold;
        letter-spacing: 0.06px;
        line-height: 20px;
        max-width: 150px;
        padding-top: 13px;
      }
    }

    &:nth-child(2) {
      max-width: 135px;
      margin-right: 55px;

      @media only screen and (max-width: 767px) {
        margin-right: 15px;
        line-height: 1.2;
      }

      .speaker-images-wrapper {
        position: relative;
        display: block;
        margin-bottom: 20px;

        .speaker-image {
          margin: auto;
        }

        /* .speaker-by-image {
          bottom: -15px;
          right: -15px;
        } */
      }

      /* .speaker-title {
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.06px;
      } */
    }

    &:nth-child(3) {
      flex: 2;

      .title {
        font-size: 36px;
        letter-spacing: -0.27px;
        line-height: 41px;

        @media only screen and (max-width: 767px) {
          font-size: 24px;
          line-height: 1.2;
        }
      }

      .subtitle {
        color: ${({ theme: { colors } }) => colors.pink};
        font-size: 16px;
        letter-spacing: 0.06px;
        line-height: 1.4;
        margin-bottom: 5px;

        br {
          display: none;
        }
      }
    }

    &:last-child {
      padding-bottom: 15px;

      .more-info-link {
        display: block;
        color: ${({ theme: { colors } }) => colors.pink};
        font-size: 14px;
        letter-spacing: 0.1px;
        line-height: 17px;
        margin-top: 15px;
      }
    }
  }
`;
